import styled from 'styled-components';

export const EditorLabel = styled.div`
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  width: 100%;
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1rem;
  font-weight: 400;
`;

export const StyledItemEditor = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 2px solid rgba(0, 0, 0, 0.36);
  background: ${({ theme }) => theme.background};
`;

export const EditorContent = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  overflow: hidden;
`
export const ItemAssets = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;

export const ItemParams = styled.div`
  width: 100%;
  height: 30%;
  gap: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
`;

export const ItemParam = styled.div`
  width: 50%;
  height: 100%;
`;

export const ItemAsset = styled.div`
  width: 50%;
  height: 100%;
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ItemList = styled.div`
  width: 20%;
  max-height: 100%;
  height: 100%;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.36);
  padding: ${({ theme }) => theme.frameWidth};
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
`;

export const ItemListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.frameWidth};
`;

export const InternalItem = styled.div`
  display: flex;
  cursor: pointer;
  width: 100%;
  padding: 0.5rem;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  background: ${({ theme, $selected }) => $selected ? theme.selection : theme.buttonLightBlue};
  transition: all linear .2s;
  text-transform: uppercase;
  font-family: "BebasNeue";
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;

  &:hover {
    background: ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
  }
`;

export const InternalItemInfo = styled.div`
  padding-top: 4px;
  width: 100%;
  color: black;
`;

export const ItemDataSection = styled.div`
  width: 50%;
  height: 100%;
`;
